/**
 * The password rule the hub enforces, mirrored for the two forms that ask for
 * one (the change-password card on Me, and the first-admin sign-up).
 *
 * Mirrored from core's `PASSWORD_MIN_LENGTH` rather than imported, for the same
 * reason `event-kinds.ts` is: a value import of `@dyspatch/core` pulls
 * `node:crypto` into the browser bundle. `packages/hub/test/web.test.ts` pins the
 * two together, so a hub that tightens the rule without telling the form fails
 * `bun test` rather than letting the form promise something the server refuses.
 */
export const PASSWORD_MIN_LENGTH = 8;

/**
 * What is wrong with a proposed new password, or null when the hub would take
 * it. Only the checks the browser can make; the current password is the hub's
 * to verify.
 */
export function passwordProblem(next: string, confirm: string): string | null {
  if (next.length < PASSWORD_MIN_LENGTH) {
    return `At least ${PASSWORD_MIN_LENGTH} characters.`;
  }
  if (confirm !== next) return 'The two passwords do not match.';
  return null;
}
